import { Router, type IRouter } from "express";
import healthRouter from "./health";
import splayRouter from "./splay";
import adminRouter from "./admin";
import sitemapRouter from "./sitemap";

const router: IRouter = Router();

router.use(healthRouter);
router.use("/splay", splayRouter);
router.use("/splay", sitemapRouter);
router.use("/admin", adminRouter);

export default router;
